import PropTypes from 'prop-types'
import React, { Component } from 'react'
import _ from 'lodash'
import CartItem from './CartItem'
import './styles.css'
import { cartItemPropTypes } from './CartItem'

export class CartItemList extends Component {
  render() {
    return (
      <article id="CartItemList">
        {!this.props.isMobile && (
          <div className="header">
            <div className="items">items</div>
            <div className="price">price</div>
            <div className="quantity">quantity</div>
            <div className="subtotal">subtotal</div>
            <div className="remove" />
          </div>
        )}
        {this.props.isMobile && (
          <div className="header-mobile">
            <section className="heading"><h1>Items</h1></section>
          </div>
        )}
        <section className="cart-item-list-content">
          {this.props.items && this.props.items.map(item => (
            <CartItem
              key={item.id}
              {...item}
              loading={this.props.loading}
              isMobile={this.props.isMobile}
              subscription={this.props.subscription}
              discountPercentage={this.props.subscriptionDiscount}
            />
          ))}
        </section>
      </article>
    )
  }
}

CartItemList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(cartItemPropTypes)),
  loading: PropTypes.number,
  plans: PropTypes.arrayOf(
    PropTypes.shape({
      description1: PropTypes.string,
      description2: PropTypes.string,
      description3: PropTypes.string,
      firstMonthPrice: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      owned: PropTypes.bool,
      price: PropTypes.number,
      rank: PropTypes.number,
      regularPrice: PropTypes.number,
      trial: PropTypes.string,
      url: PropTypes.string,
      videoTutorialDiscount: PropTypes.number,
      webinarDiscount: PropTypes.number,
      merchDiscount: PropTypes.number
    })
  )
}

CartItemList.defaultProps = {
  items: [],
  loading: 0,
  plans: []
}

export default CartItemList
